import { ThemeEvents, CartUpdateEvent } from '@theme/events';

/**
 * Gift-with-purchase: automatically adds a free item to the cart when a
 * specific trigger product is added, without touching the core add-to-cart flow.
 * Fails silently on any error so it can never block or break the primary
 * add-to-cart, checkout, or cart experience.
 */

// Cada modelo de Water Ritual™ regala su propio filtro (tamaños distintos, no intercambiables).
const GIFTS_BY_TRIGGER = {
  // KATSHU™ Water Ritual™ Pocket → Filtros de Repuesto, variante "Pocket (1000 ml)"
  '12056188322056': '58888318025992',
  // KATSHU™ Water Ritual™ Signature → Filtros de Repuesto, variante "Signature (1500 ml)"
  '12298735583496': '58888318058760',
};

/**
 * @returns {string[]} The section ids currently rendered on the page that need updating.
 */
function getCartSectionIds() {
  const ids = new Set();
  document.querySelectorAll('cart-items-component[data-section-id]').forEach((el) => {
    const id = /** @type {HTMLElement} */ (el).dataset.sectionId;
    if (id) ids.add(id);
  });
  return Array.from(ids);
}

/**
 * @param {CustomEvent} event
 */
async function maybeAddGift(event) {
  try {
    const data = event.detail?.data;
    if (!data || data.source !== 'product-form-component' || data.didError) return;

    const giftVariantId = GIFTS_BY_TRIGGER[String(data.productId)];
    if (!giftVariantId) return;

    const cart = event.detail.resource;
    if (!cart?.items) return;

    const alreadyHasGift = cart.items.some((item) => String(item.variant_id) === giftVariantId);
    if (alreadyHasGift) return;

    const sections = getCartSectionIds();

    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(giftVariantId), quantity: 1 }],
        sections: sections.join(','),
        sections_url: window.location.pathname,
      }),
    });

    const result = await response.json();
    if (result.status) return;

    const cartResponse = await fetch('/cart.js');
    const updatedCart = await cartResponse.json();

    document.dispatchEvent(
      new CartUpdateEvent(updatedCart, 'gift-with-purchase', {
        source: 'gift-with-purchase',
        sections: result.sections,
      })
    );
  } catch (error) {
    console.error('gift-with-purchase failed to add gift item:', error);
  }
}

document.addEventListener(ThemeEvents.cartUpdate, maybeAddGift);
